<template>
    <div class="share-wrapper form-type-2" v-if="shareLink">
        <CustomInput
            inputKey="dataset_share"
            :class="{ 'copied': copied }"
            :showLabel="true"
            v-model="shareLink"
            :disabled="true"
            @click.stop="copyToClipboard(shareLink)"
        />

        <div v-if="!copied" class="btn-1 btn-s-icon" @click.stop="copyToClipboard(shareLink)">
            <div class="icon-copy-pos"></div>
        </div>

        <div v-else class="btn-7 btn-s-icon">
            <div class="icon-check-pos"></div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import { useDatasetStore } from '@/stores/dataset';
    import CustomInput from '@/components/elements/inputs/CustomInput'
    import { copyToClipboard } from '@/utils/clipboard';

    export default {
        name: 'DatasetShare',
        components: {
            CustomInput
        },
        data() {
            return {
                copied: false
            }
        },
        computed: {
            ...mapState(useDatasetStore, ['shareLink']),
            datasetStore() {
                return useDatasetStore();
            }
        },
        methods: {
            copyToClipboard(shareLink) {
                copyToClipboard(shareLink);
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 1500);
            }
        }
    }
</script>